export default class CustomNotificationDetailCtrl{

  constructor($scope, $state, $stateParams, GeneralSettingsSrv,$cookies, Validations){
    var customNotificationVm = this
    const user = JSON.parse($cookies.get('currentUser'))
    const currentRoleId = JSON.parse($cookies.get('hasRoleId'))

    customNotificationVm.faculties = {}
    customNotificationVm.teachers = {}
    customNotificationVm.deliveryType = {}
    customNotificationVm.submodules = {}
    customNotificationVm.notificationTypes = {}
    customNotificationVm.selectedDeliveryType = []
    customNotificationVm.selectedTeachers = []
    customNotificationVm.deliveryDate = null

    customNotificationVm.exists = exists

    activate()

    function activate () {

      if( !$stateParams.notificationId ) $state.go('generalSettings.notificationsManagement')

      return getCustomNotificationData().then(
        getNotification($stateParams.notificationId).then( () => {} )
      )
    }

    function getCustomNotificationData() {
      let header = { }
      if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)){
        header.userId = user.id
        header.rolId  = currentRoleId
      }
      return GeneralSettingsSrv.customNotificationData.getList(header).$promise.then( (dataReturn) => {
        if(dataReturn.status == true){
          loadFormData( dataReturn.data )
        } else {
          console.log("Comunications problem with the server")
        }
      }, (data) => {
        console.log(data);
      })
    }

    function getNotification( notificationId ) {
      return GeneralSettingsSrv.getNotificationById.get({notificationId: notificationId}).$promise.then(function(dataReturn) {
        if( dataReturn.status == true ){
          if( dataReturn.data && dataReturn.data[0] )
          {
            formatCustomNotification( dataReturn.data[0])
          }
        }else{

        }

        },function(data) {
          console.log(data)
      })
    }


    function exists(item) {
      return customNotificationVm.selectedDeliveryType.indexOf(item.toString()) > -1
    }


    function formatCustomNotification( customNotification ) {
      customNotificationVm.selectedNotificationType = customNotification.id_notificationType
      customNotificationVm.selectedFaculty = customNotification.id_faculty
      customNotificationVm.deliveryDate = moment(customNotification.dt_sending , 'YYYY-MM-DD').toDate()
      customNotificationVm.selectedModule = customNotification.id_submodule
      customNotificationVm.comments = customNotification.ds_description_custom
      customNotificationVm.asunto = customNotification.asunto

      if( customNotification.id_notification_delivery_type )
        customNotificationVm.selectedDeliveryType = customNotification.id_notification_delivery_type.split(',')

      if ( customNotification.id_teacher )
        customNotificationVm.selectedTeachers.push(customNotification.teacher_name)

    }

    function loadFormData( data ) {
      customNotificationVm.faculties = data.faculties
      customNotificationVm.teachers = data.teachers
      customNotificationVm.deliveryType = data.deliveryType
      customNotificationVm.submodules = data.submodules
      customNotificationVm.notificationTypes = data.notificationTypes
    }
  }//FIN DEL CONSTRUCTOR

    preventInput(event){
      var  vKey = 86
      if (event.keyCode == vKey)
        event.preventDefault()
      return;     
    }
}

CustomNotificationDetailCtrl.$inject = ['$scope', '$state','$stateParams', 'GeneralSettingsSrv','$cookies', 'Validations'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/notifications/custom/customNotificationDetailCtrl.js